module.exports = __webpack_public_path__ + "img/header-weddingRingsWaveDesign.f18fde4.webp";